module.exports = __webpack_public_path__ + "img/p1-p1-bg.97d401ec.gif";